import { twMerge } from 'tailwind-merge';

export const Loading = ({ className }: { className?: string }) => {
  return <p className={twMerge('animate-pulse text-neutral-100 uppercase flex items-end', className)}>Loading...</p>;
};
